import * as types from '../../action-types';
import {getSingleEmergencyContact as initialState } from "../../initialState";

const getSingleEmergencyContact = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_SINGLE_EMERGENCY_CONTACT_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_SINGLE_EMERGENCY_CONTACT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_SINGLE_EMERGENCY_CONTACT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_SINGLE_EMERGENCY_CONTACT_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getSingleEmergencyContact;
